import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languagedetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    detection: {
      // order and from where user language should be detected
      // Priority: URL param → localStorage → English fallback
      // NOTE: 'navigator' intentionally EXCLUDED to prevent automatic browser/system language detection
      // German (and other languages) should ONLY be used when explicitly selected by user
      order: ['querystring', 'localStorage'],
      // cache user language on
      caches: ['localStorage'], // Store in localStorage for quick retrieval on return visits
      // Use 'scrolled_preferred_language' as the key
      lookupLocalStorage: 'scrolled_preferred_language',
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // Supported languages (must match languageDetectionService.js)
    supportedLngs: ['en', 'it', 'es', 'de', 'fr', 'el', 'pt', 'zh', 'ja', 'ru', 'fa', 'ar'],

    // Namespaces to load
    ns: ['translation'],
    defaultNS: 'translation',

    // Path where resources get loaded from
    backend: {
      // Add cache buster to force reload of translation files
      loadPath: `/locales/{{lng}}/translation.json?v=${new Date().getTime()}`,
    }
  });

export default i18n;
